import React from "react";
import * as Commonstyles from "../styles/Common";

interface Props {
  title: string;
  first: string;
  second: string;
  firstclick: any;
  secondclick: any;
}

const Modal = ({ title, first, second, firstclick, secondclick }: Props) => {
  return (
    <div>
      <Commonstyles.ModalBack>
        <Commonstyles.ModalWrapper>
          <div>{title}</div>
          <div>
            <p onClick={secondclick}>{second}</p>

            <p className="right" onClick={firstclick}>
              {first}
            </p>
          </div>
        </Commonstyles.ModalWrapper>
      </Commonstyles.ModalBack>
    </div>
  );
};

export default Modal;
